import { config } from 'api';

import { UNKNOWN_ERROR } from 'utils/errors';
import { Url } from 'utils/url';

export const FETCH_BREADCRUMBS_CHILD_CATEGORIES_SUCCESS = 'FETCH_BREADCRUMBS_CHILD_CATEGORIES__SUCCESS';
export const FETCH_BREADCRUMBS_CHILD_CATEGORIES_ERROR = 'FETCH_BREADCRUMBS_CHILD_CATEGORIES__ERROR';

export const getBreadcrumbsUrl = (categoryIds = []) =>
  new Url(`${config.apiBasePath}/breadcrumbs`)
    .addQueryParameter('tags', categoryIds)
    .toString();

export function receiveBcrumbsChildCategories(data) {
  return {
    type: FETCH_BREADCRUMBS_CHILD_CATEGORIES_SUCCESS,
    data,
  };
}

export function receiveBcrumbsChildCategoriesError(json) {
  return {
    type: FETCH_BREADCRUMBS_CHILD_CATEGORIES_ERROR,
    error: json.error,
  };
}

export function fetchBreadcrumbsChildCategories(categoryIds) {
  return (dispatch, store, { network }) => network
    .get(getBreadcrumbsUrl(categoryIds))
    .then((data) => {
      dispatch(receiveBcrumbsChildCategories(data));
    })
    .catch(err => {
      dispatch(receiveBcrumbsChildCategoriesError(err.data || UNKNOWN_ERROR));
    });
}
